<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <vsud-alert v-if="showAlert" icon="fa fa-bell" dismissible="true" color="success">
            {{ msgAlert }}
        </vsud-alert>
        <scheme-table />
      </div>
    </div>
  </div>
</template>

<script>
import SchemeTable from "@/views/scheme/components/Table.vue";
import VsudAlert from "@/components/VsudAlert.vue";

export default {
  name: "schemes",
  data()
  {
    return {
      showAlert : false,
      msgAlert  : '',
    }
  },

  created ()
  {
    this.checkAlert();
  },

  components: 
  {
    SchemeTable,
    VsudAlert
  },

  methods : 
  {
    checkAlert()
    {
      const status = this.$route.params.status;
      const token  = this.$store.state.alertToken;

      if(token==status&&token!='')
      {
        this.showAlert = true;
        this.msgAlert  = 'Scheme addedd successfully';
        this.$store.dispatch('setAlertToken', '');
      }
    }
  }
};
</script>